import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'nova-match-category-chip',
    templateUrl: './match-category-chip.component.html',
    styleUrls: ['./match-category-chip.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class MatchCategoryChipComponent {
    @Input() matchCategory: string | undefined;
    @Input() dataQaId?: string = 'match-category-chip';
}
